// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","servicePrice":"servicePrice-Srw60","additionalServices":"additionalServices-3vEIz","seats":"seats-2XCwN"};